import React, { Component } from 'react'
import { connect } from 'react-redux';
import cn from 'classnames';

import Modal from '../../../common/Modal';
import Button from '../../../forms/Button';
import { formatError, getDayAndMonth } from '../../../helpers/formatters';
import ErrorIcon from './ErrorIcon';
import { unpaidPurchase } from 'app/routes';
import { mergePurchases } from '../../../billing/purchases/actions';
import Checkbox from '../../../forms/Checkbox';
import Warning from 'notifications/Warning';
import CloseIcon from './CloseIcon';
import { fetchMergePurchasePrice as fetchMergePurchasePriceApi } from '../../purchases/api';
import CircleLoader from '../../../common/CircleLoader';
import ChevronIcon from './ChevronIcon';

import styles from './index.module.css';

class MergePurchasesModal extends Component {

  state = {
    selectedPurchasesIds: [],
    purchasePriceCache: {},
    opennedPurchases: {},
  }

  componentDidMount() { 
    if (this.props.outerPriceErr) {
      this.setState({ priceErr: this.props.outerPriceErr });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.purchases !== this.props.purchases) {
      this.selectAllPurchases();
    }

    if (prevProps.outerPriceErr !== this.props.outerPriceErr) {
      this.setState({ priceErr: this.props.outerPriceErr });
    }
  }

  handlePurchaseIdClick = (id) => {
    this.setState(prevState => ({
      opennedPurchases: {
        ...prevState.opennedPurchases,
        [id]: !prevState.opennedPurchases[id],
      }
    }))
  }

  handleSelectedPurchaseChange = (id, e) => {
    const selected = e.target.checked;
    const { selectedPurchasesIds } = this.state;

    let newSelectedPurchases;

    if (selected) {
      newSelectedPurchases = [...selectedPurchasesIds, id];
      this.setState({ selectedPurchasesIds: newSelectedPurchases });
    } else {
      newSelectedPurchases = selectedPurchasesIds.filter(purchaseId => purchaseId !== id);
      this.setState({ selectedPurchasesIds: newSelectedPurchases });
    }

    this.fetchMergePurchasePrice(newSelectedPurchases);
  }

  selectAllPurchases = () => {
    const { purchases } = this.props;
    const newSelectedPurchases = purchases.map(purchase => purchase.id);
    this.setState({
      selectedPurchasesIds: newSelectedPurchases
    });
    this.fetchMergePurchasePrice(newSelectedPurchases);
  }

  handleContinue = () => {
    const { selectedPurchasesIds } = this.state;
    const { mergePurchases, unpaidPurchase } = this.props;
    if (!selectedPurchasesIds || !Array.isArray(selectedPurchasesIds) || selectedPurchasesIds.length === 0) {
      return;
    }

    if (selectedPurchasesIds.length === 1) {
      unpaidPurchase(selectedPurchasesIds[0]);
    }

    if (selectedPurchasesIds.length > 1) {
      mergePurchases(selectedPurchasesIds[0], { others: selectedPurchasesIds.slice(1) }, true);
    }
  }

  getSubtotal = () => {
    const { purchases } = this.props;
    const { selectedPurchasesIds } = this.state;

    const selectedPurchases = purchases.filter(purchase => selectedPurchasesIds.includes(purchase.id));

    const subtotal = selectedPurchases.reduce((sum, purchase) => {
      if (purchase && purchase.cost) {
        sum += parseFloat(purchase.cost.amount);
      }
      return sum;
    }, 0)

    return subtotal.toFixed(2);
  }

  fetchMergePurchasePrice = (ids) => {
    const { purchases, isRenewPurchase } = this.props;
    const { purchasePriceCache } = this.state;

    if (ids.length === purchases.length && !isRenewPurchase) {
      return;
    }

    const key = ids.sort().join('');
    if (!purchasePriceCache[key] && ids.length > 1) {
      this.setState({ loading: true });
      fetchMergePurchasePriceApi({ids})
        .then(response => {
          const priceObj = response.data;
          this.setState({
            purchasePriceCache: {
              ...purchasePriceCache,
              [key]: priceObj,
              [key+'Error']: null
            },
            priceErr: null,
            loading: false,
          });
        })
        .catch(e => {
          this.setState({
            purchasePriceCache: {
              ...purchasePriceCache,
              [key+'Error']: (e.response && e.response.data) || true,
            },
            priceErr: null,
            loading: false,
          });
        })
    } else if (ids.length === 1) {
      this.setState({
        priceErr: null,
      });
    }
  }

  renderLines = () => {
    const { purchases } = this.props;
    const { selectedPurchasesIds, opennedPurchases } = this.state;
    console.log(purchases)
    if (purchases.length === 1) {
      return null
    }

    return (
      <ul className={styles.list}>
        {purchases.length !== 1 && purchases.map(purchase => (
          <li key={purchase.id} className={styles.itemWrapper} >
            <div onClick={() => this.handlePurchaseIdClick(purchase.id)} className={cn(styles.item, {[styles.itemUnselected]: !selectedPurchasesIds.includes(purchase.id) })}>
              <Checkbox
                input={{ 
                  onChange: (e) => this.handleSelectedPurchaseChange(purchase.id, e),
                  value: selectedPurchasesIds.includes(purchase.id),
                  name: purchase.id
                }}
                wrapperClassName={styles.checkbox}
              />
              <span className={styles.purchaseId} >#{purchase.id}</span>
              <span className={styles.date}>{getDayAndMonth(new Date(purchase.created_at))}</span>
              <span className={styles.price}>
                ${purchase.cost && purchase.cost.amount}&nbsp;&nbsp;&nbsp;
              </span>
              <div className={styles.chevron}>
                <ChevronIcon
                  isActive={opennedPurchases[purchase.id]}
                  isDisabled={!selectedPurchasesIds.includes(purchase.id)}
                />
              </div>
            </div>
            { opennedPurchases[purchase.id] && (
              <div className={styles.lineItemsWrapper}>
                <Checkbox
                  input={{ 
                    onChange: (e) => {},
                    value: selectedPurchasesIds.includes(purchase.id),
                    name: purchase.id
                  }}
                  wrapperClassName={styles.checkbox}
                />
                <span className={styles.purchaseId}>#{purchase.id}</span>
              
                <div className={styles.lineItems}>
                  {purchase.line_items.map(item => (
                    <div className={styles.lineItem} key={item.id}>
                      {item.title} <span>${item.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </li>
        ))}
        {purchases.length !== 1 && (
          <li className={styles.subtotal}>Subtotal: ${this.getSubtotal()}</li>
        )}
      </ul>
    )
  }

  render() {
    const { isOpen, closeModal, purchases, isRenewPurchase } = this.props;
    const { selectedPurchasesIds, purchasePriceCache, priceErr, loading } = this.state;

    let priceObj;
    let priceError = priceErr;
    if (selectedPurchasesIds.length === purchases.length && !isRenewPurchase) {
      priceObj = this.props.priceObj;
      priceError = this.props.outerPriceErr;
    } else if (selectedPurchasesIds.length > 1) {
      const key = selectedPurchasesIds.sort().join('');
      priceObj = purchasePriceCache[key];
      priceError = purchasePriceCache[key + 'Error'];
    } else if (selectedPurchasesIds.length === 1) {
      const purchase = purchases.find(p => p.id === selectedPurchasesIds[0])
      priceObj = purchase.cost;
    } else {
      priceObj = { total: 0 };
    }
    
    const formattedPriceError = priceError && formatError(priceError);
    const priceErrorToDisplay = formattedPriceError && formattedPriceError.replaceAll(/\n/gi, '') !== 'Ids: All purchases should have the same zip_code'
      ? formattedPriceError
      : `Selected purchases can't be merged into a single invoice`

    return (
      <Modal modalClassName={styles.modal} isOpen={isOpen} onClose={closeModal}>
        <CloseIcon className={styles.close} onClick={closeModal} />
        <div className={styles.wrapper}>
          <ErrorIcon/>
          <h3 className={styles.title}>
            Please settle your<br/>
            outstanding invoices
          </h3>
          {this.renderLines()}
          {(!priceError || loading) && (
            <div className={styles.total}>
              <span className={styles.finalTotal}>Final Total</span>
              <span className={styles.totalPrice}>${priceObj ? priceObj.total : '...'}</span>
              <span className={styles.withTaxes}>with taxes and fees</span>
              {loading && (
                <div className={styles.loaderWrapper}>
                  <CircleLoader className={styles.loader} showLoader />
                </div>
              )}
            </div>
          )}
          {priceError && <div className={styles.errorMessage}>{priceErrorToDisplay}</div> }
          <Button
            className={styles.button}
            disabled={selectedPurchasesIds.length === 0 || priceError || loading}
            onClick={this.handleContinue}
          >
            Continue to Checkout
          </Button>
          { selectedPurchasesIds.length > 1 && (
            <p className={styles.smallText}>
              Selected will be merged into a single invoice. This action cannot be undone.
            </p>
          )}
          <Warning name="mergePurchases" />
        </div>
      </Modal>
    )
  }
}

const mapDispatchToProps = {
  mergePurchases,
  unpaidPurchase,
}

export default connect(null, mapDispatchToProps)(MergePurchasesModal);
